import React from 'react';
import propTypes from 'prop-types';
;
import { Button, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal } from 'src/ui/mui-ui-kit';;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FadeInDiv, AnimatedCard } from '../logic';
import { usePoseWithBulma } from '../hooks';

export function ConfirmChangesModal({
  title,
  text,
  isActive,
  onClickCancel,
  onClickSubmit,
}) {
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );

  return (
    <Modal isActive={isModalVisible} className="confirm-changes-modal">
      <ModalBackground
        tag={FadeInDiv}
        pose={currentPose}
        onPoseComplete={onPoseComplete}
      />
      <ModalCard tag={AnimatedCard} pose={currentPose}>
        <ModalCardHeader>
          <ModalCardTitle
            tag="h6"
            hasTextAlign="centered"
            className="has-text-weight-semibold"
          >
            Confirm Changes
          </ModalCardTitle>
        </ModalCardHeader>
        <ModalCardBody hasTextAlign="centered">
          <span className="icon is-large has-icon-gradient-warning">
            <FontAwesomeIcon
              icon={['fal', 'exclamation-circle']}
              className="is-size-2"
            />
          </span>
          <p className="has-text-grey-medium-dark">
            {text}
            <b className="is-size-5 has-text-weight-semibold has-text-info is-block">
              {title}
            </b>
          </p>
          <div className="buttons is-centered">
            <Button
              isColor="gradient-bright"
              className="is-long"
              type="submit"
              onClick={onClickSubmit}
            >
              Save
            </Button>
            <Button
              isOutlined
              className="is-long"
              hasTextColor="info"
              onClick={onClickCancel}
            >
              Cancel
            </Button>
          </div>
        </ModalCardBody>
      </ModalCard>
    </Modal>
  );
}

ConfirmChangesModal.defaultProps = {
  onClickCancel: () => {},
  onClickSubmit: () => {},
  text: 'Would you like to save all changes to',
};

ConfirmChangesModal.propTypes = {
  title: propTypes.string.isRequired,
  text: propTypes.string,
  isActive: propTypes.bool.isRequired,
  onClickCancel: propTypes.func,
  onClickSubmit: propTypes.func,
};
